import { DiagnosticsImagingSection } from "@/features/patient/diagnostics/components/DiagnosticsImagingView";
import { useDiagnosticsImaging } from "@/features/patient/diagnostics/utils/adaptDiagnostics";
import { useSearchFocusParam } from "@/shared/hooks/useSearchFocus";

export function DiagnosticsPage() {
  const { labResults, isLoading } = useDiagnosticsImaging();
  const focus = useSearchFocusParam();
  return (
    <DiagnosticsImagingSection
      labResults={labResults}
      isLoading={isLoading}
      focus={focus}
    />
  );
}
